import { useState } from "react";
import { embedUrl, parseVideo } from "../../lib/video.js";
import { videoTitle } from "../../lib/videos.js";
import { track } from "../../lib/analytics.js";
import Picture, { CARD } from "../Picture/Picture.jsx";
import styles from "./VideoReel.module.css";

const displayTitle = (title) => title.replace(/^3D Visualization:\s*/, "");

/**
 * A row of video panels: one wide and playable, the rest narrow slivers that widen a
 * little on hover and become the wide panel when clicked. Vimeo ids only; each needs a
 * poster at /images/video-posters/<id> (see scripts/legacy-media.txt).
 */
export default function VideoReel({ videos, label }) {
  const [active, setActive] = useState(0);
  const [playing, setPlaying] = useState(false);

  return (
    <ul className={styles.reel} aria-label={label}>
      {videos.map((id, i) => {
        const title = videoTitle(id);
        const isActive = i === active;
        return (
          <li key={id} className={`${styles.item} ${isActive ? styles.active : ""}`.trim()}>
            {isActive && playing ? (
              <iframe
                className={styles.frame}
                src={embedUrl(parseVideo(String(id)))}
                title={title}
                allow="autoplay; fullscreen; picture-in-picture"
                allowFullScreen
              />
            ) : (
              <>
                <Picture
                  src={`/images/video-posters/${id}`}
                  alt=""
                  {...CARD}
                  sizes="(min-width: 64rem) 42rem, 100vw"
                  className={styles.poster}
                />
                {/* One button per panel, relabelled rather than swapped, so keyboard
                    focus stays put when a sliver becomes the wide panel. */}
                <button
                  type="button"
                  className={styles.hit}
                  aria-label={isActive ? `Play video: ${title}` : `Show video: ${title}`}
                  onClick={() => {
                    if (isActive) {
                      setPlaying(true);
                      track("video_play", { video_title: title });
                    } else {
                      setActive(i);
                      setPlaying(false);
                    }
                  }}
                >
                  <span className={styles.play} aria-hidden="true" />
                  <span className={styles.title}>{displayTitle(title)}</span>
                </button>
              </>
            )}
          </li>
        );
      })}
    </ul>
  );
}
